import { takeLatest, all, put, race, take, call, select, fork } from "redux-saga/effects";
import * as Store from './giveFeedbackStore';
import * as feedbackApi from '../../api/feedbackApi';
import { ApplicationState } from "../../store";
import { momentToDtoString } from "../../utils/dateUtilities";
import * as moment from 'moment';
import * as Notifications from '../../notifications/notificationsStore'
import { localizations } from '../../localization/localization';

export function* watchGiveFeedbackSagas() {
    yield all([
        takeLatest(Store.ActionType.GiveFeedback, giveFeedbackFlow)
    ]);
}

const getUser = (state: ApplicationState) => state.login;

function* feedBackSuccess(){
    yield put(Notifications.actionCreators.addNotification({id: "feedBackSuccess", message: localizations.store.feedBackSuccess , variant: "success", autohide: true }));
}
function* feedBackError(){
    yield put(Notifications.actionCreators.addNotification({id: "feedBackError", message: localizations.store.feedBackError, variant: "error", autohide: true }));
}


function* giveFeedbackFlow() {
    yield put(Store.actionCreators.giveFeedbackStarted());

    const { submit, cancel } = yield race({
        submit: take(Store.ActionType.GiveFeedbackSubmit),
        cancel: take(Store.ActionType.GiveFeedbackCancel)
    })

    if (submit) {

        const userData = yield select(getUser);

        if (userData) {

            const now = moment();

            const data = Object.assign({}, submit.data,
                {
                    date: momentToDtoString(now),
                    userId: userData.userId
                })

            const succeeded = yield call(feedbackApi.addFeedback, data);
            if (succeeded) {
                yield put(Store.actionCreators.giveFeedbackFinished());
                yield fork(feedBackSuccess);
            }
            else {
                yield fork(feedBackError);
            }
        }
        else {
            yield fork(feedBackError);
        }
    }
    else if (cancel) {
        yield put(Store.actionCreators.giveFeedbackFinished());
    }
    else {
        yield fork(feedBackError);
    }
}


// WEBPACK FOOTER //
// ./src/feedback/store/sagas.ts